export enum SaleMediumEnum {
  Hotel_Restaurant_Pub = 1,
  Retail_Wholesale = 2,
  Take_Away = 3,
  Vending = 4
}

export enum SaleMediumNameValueEnum {
  Hotel_Restaurant_Pub = 'Hotel, Restaurant, Pub etc',
  Retail_Wholesale = 'Retail / Wholesale',
  Take_Away = 'Take-away',
  Vending = 'Vending'
}